export const getAllPermissionAccessTypes = () =>
  ['None', 'View', 'Manage'].map(key => ({
    key,
    label: key,
    value: key,
  }))
